import { createAdminAccountSubmissionPreviews } from "./AdminAccountSubmissionPreviews";

export const AdminAccountSubmissionPreviewsClosed = createAdminAccountSubmissionPreviews(
	"admin_account_submissions_closed",
	(account) =>
		!account.hasBeenActive && (account.status === "closed" || account.status === "declined"),
);
